import React from 'react';
import { DefaultToastContainer } from 'react-toast-notifications';

/**
 * Custom ToastContainer that wraps the default one.
 * Preserves all existing toast behavior while adding a custom class and id
 * for styling (position, size, etc.).
 */
const CustomToastContainer = (props) => (
  <DefaultToastContainer
    {...props}
    className={`react-toast-notifications__container custom-toast-container ${
      props.className || ''
    }`.trim()}
    id="app-toast-container"
  />
);

export default CustomToastContainer;
